module.exports = __webpack_public_path__ + "img/aaa.ce6e882f.png";